/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetPromptVersionRequest = {
  id: string;
  version: number;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetPromptVersionRequest$inboundSchema: z.ZodType<
  GetPromptVersionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  version: z.number().int(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetPromptVersionRequest$Outbound = {
  id: string;
  version: number;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetPromptVersionRequest$outboundSchema: z.ZodType<
  GetPromptVersionRequest$Outbound,
  z.ZodTypeDef,
  GetPromptVersionRequest
> = z.object({
  id: z.string(),
  version: z.number().int(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getPromptVersionRequestToJSON(
  getPromptVersionRequest: GetPromptVersionRequest,
): string {
  return JSON.stringify(
    GetPromptVersionRequest$outboundSchema.parse(getPromptVersionRequest),
  );
}
export function getPromptVersionRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetPromptVersionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetPromptVersionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetPromptVersionRequest' from JSON`,
  );
}
